import { IProfileUserForm, IProfileUserResponse } from 'src/types'

const generateFormState = (state: IProfileUserResponse): IProfileUserForm => ({
  email: state.email,
  mobile: state.mobile,
  image: {
    icon: state.image,
    file: null,
  },
  image_small: state.image_small,
  image_medium: state.image_medium,
  name: state.name,
  wallets: state?.wallets || [],
})

export { generateFormState }
